/* global window */
export function getDataLayer() {
	if (!window.dataLayer) {
		window.dataLayer = [];
	}

	return window.dataLayer;
}

export function triggerEvent(name = '', variables = {}) {
	const dataLayer = getDataLayer();

	const dataLayerVariables = Object.assign({}, variables, { event: name });

	dataLayer.push(dataLayerVariables);
}

export function trackStickyContactSubmit() {
	triggerEvent('StickyContactSubmit');
}

